import { render } from "./DraftBillsMailPanel.vue?vue&type=template&id=5d77e5f6"
import script from "./DraftBillsMailPanel.vue?vue&type=script&lang=js"
export * from "./DraftBillsMailPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__